import Drawer from "@base/Drawer/Drawer";

export default Drawer;
